import React from 'react';
import { Form, Col, Card } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import Swal from 'sweetalert2';

import FormActions from '../../components/FormActions';
import { AppInput, FileUpload, RichText } from '../../../../partials/form';
import { withFormValidation } from '../../../../hoc';
import { NewsApiService, NewsFileApiService } from '../../../../services';
import FormHelper from '../../../../helpers/FormHelper';
import { FlagIcon } from './components';

const initialState = {
  titlePt: '',
  titleEn: '',
  titleEs: '',
  contentPt: '',
  contentEn: '',
  contentEs: '',
  carrousel: true,
  options: [],
  newsFileId: 0,
  newsId: 0,
  file: '',
  name: '',
  currentUploudFile: null,
  expirationDate: null
};

class NewsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState
    };

    this.api = new NewsApiService();
    this.apiFile = new NewsFileApiService();
    this.handleChange = this.props.handleChange.bind(this);
    this.onCleanForm = this.props.onCleanForm.bind(this);
    this.formHelper = new FormHelper(this);
  }

  getfile = async () => {
    const modelData = await this.apiFile.get(
      `by-newsid?newsId=${this.props.match.params.id}`
    );
    const model = modelData[0];
    this.setState({
      newsFileId: model?.newsFileId || 0,
      newsId: model?.newsId || this.props.match.params.id,
      name: model?.name || '',
      currentUploudFile: model?.file
    });
  };

  componentDidMount() {
    this.formHelper.loadFromService();
    this.getfile();
    try {
      const options = [
        {
          key: true,
          // name: this.props.translate.family.tryIt
          name: 'Sim'
        },
        {
          key: false,
          // name: this.props.translate.family.release
          name: 'Não'
        }
      ];

      this.setState({ options });
    } catch (error) {
      Swal.fire(
        this.props.translate.defaultMessages.error,
        this.props.translate.defaultMessages.loadData,
        'error'
      );
    }
  }

  mapModelToStateFile(model) {
    return {
      newsFileId: model.newsFileId || 0,
      newsId: model.newsId,
      name: model.name,
      currentUploudFile: model.file
    };
  }

  mapModelToState(model) {
    const date = new Date(model.expirationDate);

    return {
      titlePt: model.titlePt,
      titleEn: model.titleEn,
      titleEs: model.titleEs,
      contentPt: model.contentPt,
      contentEn: model.contentEn,
      contentEs: model.contentEs,
      carrousel: model.carrousel,
      expirationDate: `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, 0)}-${date
        .getDate()
        .toString()
        .padStart(2, 0)}`
    };
  }

  mapStateToModel() {
    const form = {
      titlePt: this.state.titlePt,
      titleEn: this.state.titleEn,
      titleEs: this.state.titleEs,
      contentPt: this.state.contentPt,
      contentEn: this.state.contentEn,
      contentEs: this.state.contentEs,
      carrousel: this.state.carrousel,
      expirationDate: this.state.expirationDate
    };

    return form;
  }

  mapStatetoModelFile() {
    const formData = new FormData();
    formData.append('newsId', this.state.newsId);
    formData.append('name', this.state.name);
    formData.append('file.file', this.state.file);
    return formData;
  }

  handleChangeContentPt = value => {
    this.setState({ contentPt: value });
  };

  handleChangeContentEn = value => {
    this.setState({ contentEn: value });
  };

  handleChangeContentEs = value => {
    this.setState({ contentEs: value });
  };

  handleChangeDate = event => {
    this.setState({ expirationDate: event.target.value });
  };

  onSubmit = async evt => {
    evt.preventDefault();
    if (!this.props.validateForm()) {
      return;
    }

    this.props.showSpinner();

    const id = this.props.match.params.id;
    const payload = this.mapStateToModel();
    if (id) {
      await this.api.update(id, payload);
    } else {
      await this.api.create(payload);
    }
    const idFile = this.state.newsFileId;
    const payloadFile = this.mapStatetoModelFile();
    if (this.state.file && idFile) {
      await this.apiFile.update(idFile, payloadFile);
    } else if (this.state.file) {
      await this.apiFile.create(payloadFile);
    }
    this.formHelper.afterSubmit();
    this.props.hideSpinner();
  };

  render() {
    if (this.props.match.params.id) {
      window.setPageTitle(
        `${this.props.translate.screens.news.edit} - Admin` // edit
      );
    } else {
      window.setPageTitle(
        `${this.props.translate.screens.news.create} - Admin` //create
      );
    }

    const {
      titlePt,
      titleEn,
      titleEs,
      name,
      file,
      currentUploudFile,
      options,
      carrousel,
      expirationDate
    } = this.state;

    return (
      <Card className="mt-3">
        <Card.Header>
          {this.props.translate.screens.category.mainData}
        </Card.Header>
        <Card.Body>
          <Form onSubmit={this.onSubmit}>
            <Form.Row>
              <Form.Label>
                <FlagIcon
                  path={'/media/flags/255-brazil.svg'}
                  label={'Título *'}
                />
              </Form.Label>
              <AppInput
                type="text"
                name="titlePt"
                placeholder={
                  this.props.translate.screens.news.placeholders.title
                }
                maxLength="100"
                value={titlePt}
                onChange={this.handleChange}
                validator={this.props.validator}
                validations={'required|min:3|max:100'}
              />
            </Form.Row>
            <br />
            <Form.Row>
              <Form.Label>
                <FlagIcon
                  path={'/media/flags/226-united-states.svg'}
                  label={'Title *'}
                />
              </Form.Label>
              <AppInput
                type="text"
                name="titleEn"
                placeholder={
                  this.props.translate.screens.news.placeholders.title
                }
                maxLength="100"
                value={titleEn}
                onChange={this.handleChange}
                validator={this.props.validator}
                validations={'required|min:3|max:100'}
              />
            </Form.Row>
            <br />
            <Form.Row>
              <Form.Label>
                <FlagIcon path={'/media/flags/es.svg'} label={'Título *'} />
              </Form.Label>
              <AppInput
                type="text"
                name="titleEs"
                placeholder={
                  this.props.translate.screens.news.placeholders.title
                }
                maxLength="100"
                value={titleEs}
                onChange={this.handleChange}
                validator={this.props.validator}
                validations={'required|min:3|max:100'}
              />
            </Form.Row>
            <br />
            <Form.Row>
              <Form.Label>
                <FlagIcon
                  path={'/media/flags/255-brazil.svg'}
                  label={'Conteúdo *'}
                />
              </Form.Label>
            </Form.Row>
            <Form.Row>
              <RichText
                content={this.state.contentPt}
                setContent={this.handleChangeContentPt}
              />
            </Form.Row>
            <br />
            <Form.Row>
              <Form.Label>
                <FlagIcon
                  path={'/media/flags/226-united-states.svg'}
                  label={'Content *'}
                />
              </Form.Label>
            </Form.Row>
            <Form.Row>
              <RichText
                content={this.state.contentEn}
                setContent={this.handleChangeContentEn}
              />
            </Form.Row>
            <br />
            <Form.Row>
              <Form.Label>
                <FlagIcon path={'/media/flags/es.svg'} label={'Contenido *'} />
              </Form.Label>
            </Form.Row>
            <Form.Row>
              <RichText
                content={this.state.contentEs}
                setContent={this.handleChangeContentEs}
              />
            </Form.Row>
            <br />
            <Form.Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {this.props.translate.screens.news.labels.dueDate} *
                </Form.Label>
                <AppInput
                  type="date"
                  autoComplete="off"
                  value={expirationDate}
                  name="expirationDate"
                  // isInvalid={!verifyBirthday(expirationDate).isValid}
                  onChange={this.handleChangeDate}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {this.props.translate.screens.news.labels.carrossel} *
                </Form.Label>
                <Form.Control
                  name="carrousel"
                  value={carrousel}
                  validations={'required'}
                  validator={this.props.validator}
                  translate={this.props.translate}
                  onChange={this.handleChange}
                  as="select"
                >
                  <option value="">
                    {
                      this.props.translate.screens.news.labels.select
                    }
                  </option>
                  {options.map(p => (
                    <option key={p.key} value={p.key}>
                      {p.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Form.Row>
            <br />
            <Form.Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {this.props.translate.screens.news.labels.nameImage} *
                </Form.Label>
                <AppInput
                  type="text"
                  name="name"
                  placeholder={
                    this.props.translate.screens.fragrance.labels.name
                  }
                  maxLength="100"
                  value={name}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={'required|min:3|max:100'}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <FileUpload
                  label={`${this.props.translate.screens.fragrance.labels.image} *`}
                  placeholder={
                    this.props.translate.screens.fragrance.placeholders
                      .selectImage
                  }
                  name="file"
                  file={file}
                  currentUploadedFile={currentUploudFile}
                  handleChange={this.handleChange}
                  validator={this.props.validator}
                  validations={'required'}
                  accept={'image/*'}
                  translate={this.props.translate}
                />
              </Form.Group>
            </Form.Row>
            <FormActions
              module="news"
              formIsValid={true}
              onCleanForm={this.onCleanForm}
            />
          </Form>
        </Card.Body>
      </Card>
    );
  }
}

export default withRouter(withFormValidation(NewsForm, initialState));
